































import { Component, Mixins } from "vue-property-decorator";
import { AsyncUtility } from "../../../utilities";
import { DateSelectableMixin } from "./mixins";
import YearAsJapaneseCalendarEditor from "./YearAsJapaneseCalendarEditor.vue";
import DateEditor from "./DateEditor.vue";
import TimeEditor from "./TimeEditor.vue";

@Component({
  components: {
    YearAsJapaneseCalendarEditor,
    DateEditor,
    TimeEditor,
  }
})
export default class DateTimeSelector extends Mixins(DateSelectableMixin) {
  $refs!: {
    yearAsJapaneseCalendar: YearAsJapaneseCalendarEditor;
    dateEditor: DateEditor;
  };

  async onEnterKeyDown() {
    // TODO: fix だいぶしんどい対応している模様
    // フォーカスを外して入力した値が確定されるのを待つ
    this.$refs.yearAsJapaneseCalendar.setFocus();
    await this.$nextTick();
    await AsyncUtility.sleep(1);
    this.applyValue(this.editingSource);
  }

  async setFocus(): Promise<void> {
    // 起動時にフォーカスを当てたい
    // 起動直後にフォーカスを当てるとDateObjectにフォーカスを取られることがあるので
    // 少し待ってからプルダウンにフォーカスを当てる
    await AsyncUtility.sleep(1);
    if (this.isJapaneseCalendarEditable && this.$refs.yearAsJapaneseCalendar) {
      this.$refs.yearAsJapaneseCalendar.setFocus();
    } else if (!this.isJapaneseCalendarEditable && this.$refs.dateEditor) {
      this.$refs.dateEditor.setYearSelectorFocus();
    }
  }
}
